/** CSV row builder for GST / CA report downloads. */

export function escapeCsvCell(value: unknown): string {
  const s = value == null ? "" : String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function rowsToCsv(rows: Array<Record<string, unknown>>): string {
  if (!rows.length) return "";
  const keys = Object.keys(rows[0]);
  return [
    keys.join(","),
    ...rows.map((row) => keys.map((key) => escapeCsvCell(row[key])).join(","))
  ].join("\n");
}
